import { SectionEditor, type SectionEditorProps } from './SectionEditor';

export type OverridesEditorProps = SectionEditorProps;

/**
 * OverridesEditor — kept as a stable entry point for `DesignConstructor`
 * and tests. Real grouping/search logic lives in {@link SectionEditor},
 * which renders scene-grouped `<details>` disclosures instead of the
 * previous flat list of 14 technical names.
 */
export function OverridesEditor(props: OverridesEditorProps = {}) {
  return <SectionEditor {...props} />;
}
